/**
 * Relative measure
 *
 * A measure as a percentage of the one containing it, for positioning something
 * inside a box whose own size is not known in advance.
 *
 * @param measure Measure to convert
 * @param parentMeasure Measure it is taken as a proportion of
 *
 * @returns The measure as a percentage, without the unit
 */

export const relativeMeasure = (
  measure: number,
  parentMeasure: number
): number => (measure / parentMeasure) * 100
